import React from "react";

const TEXT_CONTENT = {
  sections: [
    {
      title: "Allmänt",
      content: `
        Empathys produkter är tjänster som kan användas av en licenstagare (kunden).
      `,
    },
    {
      title: "Avgifter och betalning",
      content: `
        Kunden är skyldig att betala registreringsavgiften för tjänsten test enligt vid var tid gällande prislista. Betalning (kan ske mot faktura (pappers- eller e-faktura) alternativt) görs med kreditkort eller Swish (över internet). Empathy använder företaget PayEx för internetbetalning. PayEx är en av Nordens största betaltjänstföretag. PayEx betalningslösningar är PCI-certifierade av Visa och MasterCard. Av säkerhetsskäl lagras inte känslig betalningsinformation som exempelvis kortnummer hos Empathy. All information som läggs in krypteras istället på betalningssidorna hos PayEx som är säkrade med SSL-certifikat. Om licensen erhållits genom företag eller annan utlämnare betraktas företaget eller utlämnare som kund och reglerar avgifter mot Empathy enligt överenskommelse.
      `,
    },
    {
      title: "Anslutning",
      content: `
        För varje tjänst skapas en kod som tjänstgör som kunden användardentitet. (erhåller kunden en användaridentitet med en kod.) ta bort (Abonnenten)Köparen är ansvarig för att (varje) koden förvaras på ett betryggande sätt så att obehöriga inte kan ta del av den. Empathy har rätt att av tekniska eller driftmässiga skäl ändra kundens kod om kunden begär en ändring. Empathy får inte lämna ut kunduppgifter eller koder. (Koden säkras utöver det av kunden själv eller annan två-faktorsautentisering.) ta bort
      `,
    },
    {
      title: "Ansvar",
      content: `
        Kunden är i förhållande till Empathy ensam ansvarig för den information som överförs. Empathy är inte skadeståndsskyldigt för skada eller förlust i händelse av fördröjning, avbrott, utebliven eller felaktig leverans av data eller omständighet av liknande slag. Empathy är inte heller skadeståndsskyldigt om någon behörig eller obehörig gör intrång i abonnentens eller annans datorresurs och skaffar tillgång till, förstör eller förvanskar data eller information. Kunden får inte använda tjänsten på ett sådant sätt att avsevärda olägenheter uppstår för Empathy eller någon annan. Kunden skall hålla Empathy skadelös för krav riktade från tredje man mot Empathy på grund av användningen av tjänsten.
      `,
    },
    {
      title: "Medicinskt ansvar",
      content: `
        Innehållet i Empathys tester varken kan eller ska användas som grund för att ställa diagnos. Empathy tar inte medicinskt ansvar för deltagares/kunders hälsa, utan uppmanar alla kunder med hälsoproblem att alltid uppsöka läkare eller psykolog. Empathy tar inte ansvar för någon form av skada som kan vara ett resultat, direkt eller indirekt, av användning eller felanvändning av information som finns i eller hänvisas till i våra test.
      `,
    },
    {
      title: "Upphovsrätt",
      content: `
        Allt material på dessa sidor tillhör, och är upphovsrättsligt skyddat av Empathy. Materialet får inte kopieras, säljas, distribueras eller på något annat sätt återges utan skriftlig tillåtelse från Empathy. Användare får dock fritt göra utskrifter av materialet för privat, icke-kommersiellt bruk.
      `,
    },
    {
      title: "Omfattning",
      content: `
        Genom detta avtal angående psykologitest erbjuds kunden anslutning till Empathys tjänst. Därutöver kan kunden teckna avtal om tilläggstjänster, vilka tillhandahålls mot särskild avgift. Tjänstens omfattning specificeras närmare i samverkan med respektive program. Abonnemanget förutsätter att abonnenten har nödvändig utrustning som dator för uppkoppling till Internet och programvaror för Internetanslutning och Internetanvändning.
      `,
    },
    {
      title: "Ångerrätt",
      content: `
        Ångerrätten gäller inte för Empathys eftersom testdeltagaren formar innehållet genom sina svar. Ett samtycke till detta görs vid varje test genom att kryssa i rutan i anslutning till det aktuella testet. Se länk nedan till konsumentverket: https://www.konsumentverket.se/for-foretag/konsumentratt-for-foretagare/om-kunden-angrar- sitt-kop/
      `,
    },
    {
      title: "Avtalstid",
      content: `
        Licensen gäller enligt villkoren för respektive program, från det att kunden godkänt detta avtal. I och med att kunden registrerar sig med registreringskod har avtalet accepterats.
      `,
    },
    {
      title: "Ändringar av avtalsvillkor m.m.",
      content: `
        Empathy har rätt att ändra dessa villkor eller tjänstens omfattning tre månader efter det att abonnenten skriftligen underrättats. Mindre ändringar av villkoren eller tjänstens omfattning får dock ske en månad efter det att abonnenten skriftligen underrättats.
      `,
    },
  ],
};

const Kopvillkor: React.FC = () => {
  return (
    <div className="flex flex-col justify-center items-center text-white text-start">
      <div className="max-w-[1260px] p-7 pt-2 px-2 flex flex-col gap-[36px] bg-primary-card rounded-xl">
        {TEXT_CONTENT.sections.map((section, index) => (
          <div key={index}>
            <h3 className="font-nunito text-[24px] font-semibold leading-[32px]">
              {`${index + 1}. ${section.title}`}
            </h3>
            <p className="font-quicksand text-[16px] font-normal leading-[28px] whitespace-pre-line">
              {section.content}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Kopvillkor;
